export const WHOLESALER_MODES = {
    MAIN_TABLE: 'MainTable',
    ADD: 'Add',
    EDIT: 'Edit',
    DELETE: 'Delete',
    LOADING: 'Loading',
};

export const INITIAL_WHOLESALER_DATA = {
    name: '',
    entityName: '',
    defaultPlanID: null,
    defaultPlan: null,
    defaultWholesalerPlan: null,
    status: 0,
    isActive: true,
    enabled: true,
    businessNumber: null,
    primaryContactName: null,
    primaryContactEmail: null,
    primaryContactPhone: null,
    accountsContactEmail: null,
    supportContactEmail: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    serviceCountries: null,
    carriers: [],
    regions: [],
    plans: [],
    wholesalerBillingSettings: {
        billingNotes: [],
    },
    displayPaymentBanner: false,
    paymentBannerMessage: '',
};

export const FORM_FIELD_PATHS = {
    NAME: 'name',
    ENTITY_NAME: 'entityName',
    DEFAULT_PLAN_ID: 'defaultPlanID',
    DEFAULT_PLAN: 'defaultPlan',
    DEFAULT_WHOLESALER_PLAN: 'defaultWholesalerPlan',
    BUSINESS_NUMBER: 'businessNumber',
    PRIMARY_CONTACT_NAME: 'primaryContactName',
    PRIMARY_CONTACT_EMAIL: 'primaryContactEmail',
    PRIMARY_CONTACT_PHONE: 'primaryContactPhone',
    ACCOUNTS_CONTACT_EMAIL: 'accountsContactEmail',
    SUPPORT_CONTACT_EMAIL: 'supportContactEmail',
    ATTRIBUTE_1: 'attribute1',
    ATTRIBUTE_2: 'attribute2',
    ATTRIBUTE_3: 'attribute3',
    SERVICE_COUNTRIES: 'serviceCountries',
    CARRIERS: 'carriers',
    REGIONS: 'regions',
    PLANS: 'plans',
    WHOLESALER_ID: 'wholesalerID',
    WHOLESALER_ID_ALIAS: 'wholesalerId',
    PAYMENT_BANNER_ENABLED: 'displayPaymentBanner',
    PAYMENT_BANNER_MESSAGE: 'paymentBannerMessage',
};
